export const LAST_CHANCE_CATEGORY_IDS = [
  260, 259, 258, 257, 256, 255, 254, 253, 252, 251, 250, 249, 248, 247, 153,
]
